<div class="video-area bg-ffffff ptb-100 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="video-content" *ngFor="let Content of videoContent;">
            <h2>{{Content.title}}</h2>
            <a href="{{Content.videoLink}}" class="video-btn popup-youtube"><i class="las la-play"></i></a>
        </div>
    </div>
</div>